$(document).on('click', '.many__more', function(event) {
  event.preventDefault();
  $('.product-options-tab-header').trigger('click');
  $('html, body').animate({
    'scrollTop': $('.product__details-wrapper').position().top
  })
});

$(document).on('click', '.see__all', function(event) {
  event.preventDefault();
  console.log('see all link clicked');
  $('.need-quote a').trigger('click');
});

jQuery(document).ready(function() {
  jQuery('body').on('click', '.menu__item--cart', function(evt) {
    evt.preventDefault()
    
    jQuery('.overlay__bg.minicart').addClass('visibled')
    jQuery('.product__details').css('z-index', '-1')
    jQuery('.display_cart-overlay').css('display', 'block')
    
    jQuery('#shopify-section-header .header').css('z-index', '-1')
  });
  
  jQuery('body').on('click', '.display_cart-overlay .cart-header img, .display_cart-overlay .cart-header a', function(evt) {
    evt.preventDefault()
    
    jQuery('.overlay__bg.minicart').removeClass('visibled')
    jQuery('.product__details').css('z-index', 'initial')
    jQuery('.display_cart-overlay').css('display', 'none')
    jQuery('#shopify-section-header .header').css('z-index', '101')
  });
  
  jQuery('body').on('click', '.overlay__bg.minicart', function(evt) {
    jQuery('.product__details').css('z-index', 'initial')
    jQuery('#shopify-section-header .header').css('z-index', '101')
    jQuery('.overlay__bg.minicart').removeClass('visibled')
    jQuery('.display_cart-overlay').css('display', 'none')
  });
  
  // displayDistance = 420;
  
  jQuery('body').on('scroll', function(evt) {
    console.log(evt);
  });
  
});



// WEBPACK FOOTER //
// ../assets/js/product-effect.js